<template>
  <div class="mt-3">
    <CInput label="Username" placeholder="Please fill in the username" v-model="formComponent.username"/>
    <CInput label="First name" placeholder="Please fill in the firstname" v-model="formComponent.firstName"/>
    <CInput label="Last name" placeholder="Please fill in the lastname" v-model="formComponent.lastName"/>
    <CInput label="E-mail" placeholder="Please fill in the email" type="email" v-model="formComponent.email"/>
    <CInput label="Password" placeholder="Please fill in the password" type="password" v-if="formComponent.id === ''"
            v-model="formComponent.password"/>
    <CInput label="Telephone" placeholder="Please fill in the phone number" type="number" v-model="formComponent.tel"/>
    <CRow>
      <CCol>
        <CButton @click="cancel" class="mr-2" color="danger">Cancel</CButton>
        <CButton :disabled="validationSubmit" @click="confirm" color="success">Confirm</CButton>
      </CCol>
    </CRow>
  </div>
</template>

<script>
export default {
  name: "addUser",
  props: {
    form: Object
  },
  data() {
    return {
      formComponent: {}
    }
  },
  computed: {
    validationSubmit() {
      const checkEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
      if (this.formComponent.email !== undefined) {
        if (this.formComponent.email.match(checkEmail) && this.formComponent.firstName !== ""
            && this.formComponent.lastName !== "" && this.formComponent.username.length > 5
            && this.formComponent.password.length > 6 && this.formComponent.tel !== "" && this.checkName("firstName") && this.checkName("lastName")) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    }
  },
  watch: {
    "formComponent.tel"(value) {
      if (value !== "") {
        if (value.charAt(0) !== "0") {
          this.formComponent.tel = "0" + value
        } else if (value.length > 10) {
          this.formComponent.tel = "0"
        }
      }
    }
  },
  mounted() {
    this.formComponent = this.form
  },
  methods: {
    checkName(value) {
      let hasNumber = /\d/
      if (this.formComponent[value].match(hasNumber)) {
        return false
      } else {
        return true
      }
    },
    cancel() {
      this.$emit("cancel")
    },
    confirm() {
      this.$emit("confirm", this.formComponent)
    }
  }
}
</script>
